import * as React from "react";
import { Text, View, Image, Animated, Easing } from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import Ionicons from "@expo/vector-icons/Ionicons";
import API_KEY from "../API_KEY";
import Chart from "./Chart";
import { Card, Icon } from "react-native-elements";
import { TouchableOpacity } from "react-native-gesture-handler";
import { AsyncStorage } from "react-native";
import { LinearGradient } from "expo-linear-gradient";

const alpha = require("alphavantage")({ key: API_KEY });

const NUM_OF_DAYS_GRAPH=30

export default class HomeScreen extends React.PureComponent {
  state = {
    stockData: [
      420.98,
      423.9,
      400.51,
      388.04,
      410.83,
      406.02,
      424.68,
      420.28,
      420.63,
      425.79,
      422.64,
      421.94,
      430.83,
      439.67,
      448.88,
      461.3,
      446.65,
      442.3,
      434,
      425.92,
      425.3,
      413.98,
      425.68,
      415.09,
      448.16,
      429.01,
      419.07,
      421.2,
      407.34,
      387.79,
      380.36,
      424.23,
      449.39,
      442.15,
      423.43,
      441.76,
    ],
    currPrice: "",
    currChange: "",
    currChangePercent: "",
    imageUrl: "",
    selectedStock: false,
  };

  // "1. open": "1664.9900",
  // "2. high": "1668.8000",
  // "3. low": "1626.6400",
  // "4. close": "1650.7100",
  // "5. volume": "12577614",
  componentDidMount() {
    if (this.props.stock.symbol !== "") {
      this.fetchNewStockData();
    }
  }
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (
      this.props.stock.symbol !== prevProps.stock.symbol &&
      this.props.stock.symbol !== ""
    ) {
  
      this.fetchNewStockData();
    }
  }

  fetchNewStockData = () => {
    if (this.props.stock.symbol !== "") {
      alpha.data
        .daily_adjusted(this.props.stock.symbol)
        .then((data) => {
          let stockData = Object.keys(data["Time Series (Daily)"]).map((el) => {
            return parseFloat(data["Time Series (Daily)"][el]["4. close"]);
          });
          this.setState({
            stockData: stockData.slice(0, NUM_OF_DAYS_GRAPH)
            ,
          });
        })
        .catch((err) => {
          console.log(err);
        });
      alpha.data
        .quote(this.props.stock.symbol)
        .then((data) => {
          this.setState({
            currPrice: data["Global Quote"]["05. price"],
            currChange: data["Global Quote"]["09. change"],
            currChangePercent: data["Global Quote"]["10. change percent"],
          });
        })
        .catch((err) => {
          console.log(err);
        });
      this.getLogoImg();
    }
  };

  getLogoImg = () => {
    fetch(
      "https://eodhistoricaldata.com/img/logos/US/" +
        this.props.stock.symbol +
        ".png"
    )
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            imageUrl:
              "https://eodhistoricaldata.com/img/logos/US/" +
              this.props.stock.symbol +
              ".png",
          });
        } else {
          this.setState({
            imageUrl:
              "https://g.foolcdn.com/art/companylogos/square/" +
              this.props.stock.symbol.toLowerCase() +
              ".png",
            // "https://eodhistoricaldata.com/img/logos/US/" +
            // this.props.stock.symbol.toLowerCase() +
            // ".png",
          });
        }
      })

      .catch((error) => {});
  };

  render() {
    return (
      <View>
        {this.props.stock.symbol !== "" ? (
          <View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-evenly",
                flex: 1,
                marginTop: 5,
              }}
            >
              {this.state.imageUrl !== "" ? (
                <Image
                  source={{
                    uri: this.state.imageUrl,
                  }}
                  style={{
                    width: 60,
                    height: 60,
                    borderRadius: 10,
                    position: "relative",
                    top: -30,
                  }}
                />
              ) : null}
              <Text
                style={{
                  color: "white",
                  fontSize: 20,
                  height: 20,
                }}
              >
                {/* {this.props.stock.name} */}
                {this.props.stock.symbol}
              </Text>
              <Text
                style={{
                  color: "white",
                  fontSize: 20,
                  height: 20,
                }}
              >
                ${parseFloat(this.state.currPrice).toFixed(2)}
              </Text>
            </View>

            <LinearGradient
              style={{
                borderRadius: 30,
                margin: 30,
                height: 150,
              }}
              colors={
                this.state.currChange > 0
                  ? ["#80ffa0", "#bfffcf"]
                  : ["#ff8080", "#ffbfbf"]
              }
            >
              <View>
                {this.props.selected ? (
                  <Icon
                    name="check-circle"
                    color={this.state.currChange > 0 ? "green" : "red"}
                    size={30}
                    style={{
                      alignSelf: "flex-end",
                      margin: 10,
                    }}
                  />
                ) : (
                  <Icon
                    name="delete"
                    color={this.state.currChange > 0 ? "green" : "red"}
                    size={30}
                    style={{ alignSelf: "flex-end", margin: 10 }}
                  />
                )}

                <View
                  style={{
                    flexDirection: "row",
                    textAlign: "left",
                    fontSize: 30,
                  }}
                >
                  <Text
                    style={{
                      color: this.state.currChange > 0 ? "green" : "red",
                      alignSelf: "center",
                      fontSize: 20,
                      flex: 1,
                      paddingLeft: 20,
                      margin: -10,
                    }}
                  >
                    {this.state.currChange > 0 ? "+" : ""}

                    {parseFloat(this.state.currChange).toFixed(2)}
                  </Text>
                  <Text
                    style={{
                      color: this.state.currChange > 0 ? "green" : "red",
                      alignSelf: "center",
                      fontSize: 25,
                      margin: -50,
                      flex: 1,
                    }}
                  >
                    
                    {/* {this.state.currChange > 0 ? "🤑" : "😡"} */}

                  
                  </Text>
                  <Text
                    style={{
                      color: this.state.currChange > 0 ? "green" : "red",
                      alignSelf: "center",
                      fontSize: 25,
                      margin: -50,
                      flex: 1,
                    }}
                  >
                    

                    {this.state.currChange > 0 ? "+" : ""}
                    {parseFloat(this.state.currChangePercent).toFixed(2)}%
                  </Text>
                </View>
                <Chart
                  stockData={this.state.stockData}
                  lineColour={this.state.currChange > 0 ? "green" : "red"}
                />
              </View>
            </LinearGradient>
          </View>
        ) : null}
      </View>
    );
  }
}
